import { EntityForm } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { PcfraPerson, PcfraStatus } from '~/common/types/people';

import {
  notifyReferrerMessage,
  commonFormConfig,
  commonFormSchema,
  CommonFormValues,
} from '../config';
import { CurrentResidentsDialog } from '../CurrentResidents.styled';
import { useHandlePcfraActivity } from '../useHandlePcfraActivity';

type Props = {
  open?: boolean;
  person?: PcfraPerson;
  onClose(): void;
};

const title = 'Reconfirm suitability';

export const ReconfirmSuitabilityDialog: FunctionComponent<Props> = ({ open, person, onClose }) => {
  const handlePcfraActivity = useHandlePcfraActivity();

  const onSave = ({ note, pcfraReviewDate }: CommonFormValues) => {
    if (!person) {
      return;
    }
    const { propertyId, personId } = person;
    handlePcfraActivity({
      propertyId,
      personId,
      note,
      newPcfraStatus: PcfraStatus.Active,
      pcfraReviewDate: pcfraReviewDate || null,
      shouldNotifyReferrer: true,
    });

    onClose();
  };

  return (
    <CurrentResidentsDialog open={open} title={title} accessibleInfo={{ title }} onClose={onClose}>
      <EntityForm<CommonFormValues>
        inDialog
        schema={commonFormSchema}
        config={commonFormConfig}
        initialValue={{ pcfraReviewDate: person?.pcfraReviewDate }}
        message={notifyReferrerMessage}
        onCancel={onClose}
        onSave={onSave}
      />
    </CurrentResidentsDialog>
  );
};
